import { styled } from 'styled-components';
import { classic } from '~/themes/classic';

export const SPAdviceItem = styled.p<{ $color?: string }>`
  font-size: 0.9rem;
  color: ${({ $color }) => ($color ? $color : '#4d4d4f')};
  user-select: none;
  @media screen and (max-width: 415px) {
    font-size: 0.8rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.8rem;
  }
`;

export const SH1Menu = styled.h1<{ fontWeight?: string }>`
  font-size: 1.3rem;
  color: ${classic.token?.colorWhite};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : `normal`)};

  @media screen and (max-width: 415px) {
    font-size: 1.2rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 1.2rem;
  }
`;

export const SH2Menu = styled.h2<{ fontWeight?: string }>`
  font-size: 1.2rem;
  color: ${classic.token?.colorWhite};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : `normal`)};

  @media screen and (max-width: 415px) {
    font-size: 1.1rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 1.1rem;
  }
`;

export const SH3Menu = styled.h3<{ fontWeight?: string }>`
  font-size: 1.1rem;
  color: ${classic.token?.colorWhite};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : `normal`)};

  @media screen and (max-width: 415px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 1rem;
  }
`;

export const SPMenu = styled.p<{ fontWeight?: string }>`
  font-size: 1rem;
  color: ${classic.token?.colorWhite};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : `normal`)};

  @media screen and (max-width: 415px) {
    font-size: 0.95rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.95rem;
  }
`;

export const SLi = styled.li<{ fontWeight?: string }>`
  font-size: 1rem;
  color: ${classic.token?.colorWhite};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : `normal`)};

  @media screen and (max-width: 415px) {
    font-size: 0.95rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.95rem;
  }
`;

export const SPTitle = styled.p`
  color: ${classic.token?.colorText};
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;

  @media screen and (max-width: 415px) {
    font-size: 1.2rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 1.2rem;
  }
`;
export const SSpanTitle = styled.span<{
  $textDecoration?: string;
  $color?: string;
  $margin?: string;
  $fontSize?: string;
}>`
  color: ${({ $color }) => ($color ? $color : ` ${classic.token?.colorText}`)};
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '1.25rem')};
  font-weight: 700;
  line-height: 1;
  margin: ${({ $margin }) => ($margin ? $margin : '0')};
  text-transform: uppercase;
  text-decoration: ${({ $textDecoration }) =>
    $textDecoration ? $textDecoration : 'none'};
  @media screen and (max-width: 415px) {
    font-size: 1.15rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 300px) {
    font-size: 1.1rem;
  }
`;

export const SPDialogItem = styled.p<{ $color?: string; $fontWeight?: string }>`
  font-size: 1rem;
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : '400')};

  @media screen and (max-width: 415px) {
    font-size: 0.9rem;
    line-height: normal;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.9rem;
    line-height: normal;
  }
`;

export const SPThematique = styled.p<{ $color?: string; $fontWeight?: string }>`
  font-size: 1.5rem;
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : '400')};
  text-align: center;

  @media screen and (max-width: 415px) {
    font-size: 1.2;
    line-height: normal;
  }
  @media screen and (max-height: 600px) {
    font-size: 1.2rem;
    line-height: normal;
  }
`;

export const SPRecapItem = styled.p`
  color: ${classic.token?.colorTextSecondary};
  background-color: ${classic.token?.colorWhite};
  font-weight: 700;
  border-radius: 8px;
  font-size: 1rem;
  padding: 20px;
  margin: 10px;

  @media screen and (max-width: 415px) {
    font-size: 0.9rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.9rem;
  }
`;

export const SIcon = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  object-fit: contain;
  height: 27px;
  width: 27px;
`;

export const SDivParsedItem = styled.div<{ $textAling?: string }>`
  color: ${classic.token?.colorText};
  font-size: 1rem;
  text-align: ${({ $textAling }) => ($textAling ? $textAling : 'center')};

  & > p {
    & > span {
      &.c1 {
        color: #2379cd;

        font-weight: 700;
      }
      &.c2 {
        color: #c28924;
        font-weight: 700;
      }
    }
  }

  @media screen and (max-width: 415px) {
    font-size: 0.9rem;
  }
  @media screen and (max-height: 600px) {
    font-size: 0.9rem;
  }
`;

export const Wrapper = styled.div<{
  innerHeight?: number;
  backgroundWrapper?: string;
  backgroundSize?: string;
}>`
  align-items: center;
  aspect-ratio: 16/27;
  background-image: ${({ backgroundWrapper }) =>
    backgroundWrapper ? `url('${backgroundWrapper}')` : 'none'};
  background-size: ${({ backgroundSize }) => backgroundSize ?? 'auto'};
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;

  @media screen and (min-aspect-ratio: 16/27) {
    height: ${({ innerHeight }) => {
      if (innerHeight) return `${innerHeight}px`;

      return '100%';
    }};
    width: ${({ innerHeight }) => {
      if (innerHeight) {
        const _w = Math.round((innerHeight * 16) / 27);

        return `${_w}px`;
      }

      return '100%';
    }};
  }
  @media screen and (max-aspect-ratio: 16/27) {
    height: 100%;
    width: 100%;
  }
`;

export const SDivFilterElement = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  & > *:first-of-type {
    margin-right: 5px;
  }
`;

export const SDivAutor = styled.div`
  width: auto;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 16px;
  font-weight: 700;
  position: absolute;
  color: ${classic.token?.colorWhite ?? '#fff'};
  text-transform: uppercase;
  top: -15px;
  border-radius: 6px;
  box-shadow:
    inset 0 3.6px 3.6px 0 rgba(255, 255, 255, 0.35),
    inset 0 -3.6px 3.6px 0 rgba(0, 0, 0, 0.4);
  background-color: #009ec3;
`;

// ------ site dialog

export const SBtnActionWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const SDivBlur = styled.div<{ hidden?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #17363de6;
  left: 0;
  top: 0;
  pointer-events: ${({ hidden }) => (hidden ? 'none' : 'auto')};
  height: 100%;
  transition: ${({ hidden }) =>
    hidden ? 'opacity 1s linear' : 'opacity 0.3s linear'};
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
  position: absolute;
  width: 100%;
`;

export const SDivDialog = styled.div`
  align-items: center;
  background-color: #e1eff0;
  flex-direction: column;
  border-radius: 24px 24px 0 0;
  display: flex;
  justify-content: space-around;
  height: 60%;
  padding: 20px 30px;
  transform: translateY(125%);
  width: 100%;
  transition: all 1s 0.3s ease-out;

  &.open {
    transform: translateY(0);
    transition: all 1s ease-out;
  }
`;

export const SDivSelected = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 50%;
  width: 100%;
`;

// ----- fin sites dialog
